import * as React from "react"
import { Box, Grid } from "@mui/material"
import { CardSeeker, IconSeeker, ModalSeeker } from "@ui-seeker/core"

import { TitleWithPopover } from "@components"
import { usePriceDiscountEvolutionData } from "./@hooks"
import PricingSkuEvolutionChart from "./Chart"
import PricingEvolutionSkuBlock from "./SkuBlock"
import PricingSkuEvolutionDatePeriodSelect from "./SkuBlock/DatePeriodSelect"
import PricingSkuEvolutionKpiSelect from "./SkuBlock/KpiSelect"
import PricingSkuEvolutionViewDataSelect from "./ViewSelect"


export default function PriceDiscountSkuEvolution() {
	const {
		isLoading, currentSkuSelected, data, handleSkuSelected,
        currentSku, skusSelected, isViewTopRetailersData,
        currentFiveRetailers, viewData, handleViewData, currency,
        dateRange, onChange, resetEvolutionSkuData
	} = usePriceDiscountEvolutionData()
	
	if (!data.length || isLoading) return <></>

	return <ModalSeeker 
		hideActions 
		isOpen={!!data.length} 
		title={`Price Evolution - ${currentSkuSelected.sku}`} 
		controller={() => resetEvolutionSkuData()}
		containerProps={{
			maxWidth:"xl"
		}}
	>
		<CardSeeker title={<Box id='evolution-sku-chart'></Box>}>
			<Grid container spacing={2}>
				<Grid item xs={3}>
					<PricingEvolutionSkuBlock currentSku={currentSku} skusSelected={skusSelected} currentSkuSelected={currentSkuSelected} />
				</Grid>
				<Grid item xs={9}>
					<Grid container spacing={3} justifyContent={'center'}>
						<Grid item xs={4.5}>
							<PricingSkuEvolutionDatePeriodSelect dateRange={dateRange} onChange={onChange}/>
						</Grid>

						<Grid item xs={3}>
							<PricingSkuEvolutionViewDataSelect viewData={viewData} onChange={handleViewData} />
						</Grid>

						<Grid item xs={3}>
							<PricingSkuEvolutionKpiSelect />
						</Grid>

						<Grid item xs={12}>
							<PricingSkuEvolutionChart
								data={data}
								isViewTopRetailersData={isViewTopRetailersData}
								currentFiveRetailers={currentFiveRetailers}
								currency={currency}
							/>
						</Grid>
					</Grid>
				</Grid>
			</Grid>
		</CardSeeker>
	</ModalSeeker>
}

const CardHeader = ({ currentSkuSelected, resetEvolutionSkuData }) => {
	return <Box id='evolution-sku-chart' sx={{ display: 'flex', justifyContent: 'space-between'}}>
		<TitleWithPopover title={`Price Evolution - ${currentSkuSelected.sku}`} />
		<IconSeeker 
            icon={'circle-xmark'} 
            sx={{ mr: 0.5, margin: .5, fontSize: '1.5rem', color: 'text.disabled' }} 
            tooltip={'Close Evolution Chart'}
            onClick={resetEvolutionSkuData}
        />
	</Box>
}